<section id="beneficios" class="section section-light">
	<div class="container">
		<h2>Beneficios que mejoran tu gestión todos los días</h2>
		<p class="section-lead">
			Pensado para negocios que necesitan más orden, más control y una forma más ágil de trabajar.
		</p>

		<div class="card-grid six-cols">
			<article class="card">
				<h3>Ahorro de tiempo</h3>
				<p>Reducí tareas manuales y hacé más ágil la gestión diaria desde un solo lugar.</p>
			</article>
			<article class="card">
				<h3>Orden operativo</h3>
				<p>Centralizá clientes, tareas, presupuestos, cobros, reparaciones y seguimiento en una única
					plataforma.</p>
			</article>
			<article class="card">
				<h3>Control de procesos</h3>
				<p>Organizá cada etapa de trabajo con mayor claridad y evitá errores o demoras innecesarias.</p>
			</article>
			<article class="card">
				<h3>Trazabilidad</h3>
				<p>Consultá el historial de movimientos, presupuestos, pagos y gestión de cada cliente.</p>
			</article>
			<article class="card">
				<h3>Profesionalización</h3>
				<p>Brindá una experiencia más confiable para tu cliente y más sólida para tu marca.</p>
			</article>
			<article class="card">
				<h3>Más productividad</h3>
				<p>Trabajá con información clara, mejor coordinación y una visión más completa de tu negocio en tiempo real.</p>
			</article>
		</div>
	</div>
</section>